<template>
  <el-dialog
    :visible.sync="this.dialogVisible"
    title="分享"
    width="500px"
    :before-close="handleClose"
  >
    <div class="share-wrap">
      <div class="share-title">
        {{ this.param.title }}
      </div>
      <img class="share-img" :src="this.shareImg" />
    </div>
    <template #footer>
      <span class="dialog-footer">
        <el-button type="primary" @click="downloadFileByBase64">
          下载图片
        </el-button>
      </span>
    </template>
  </el-dialog>
</template>

<script>
export default {
  data() {
    return {
      shareImg: "",
      dialogVisible: false,
      param: {},
    };
  },

  mounted() {},

  methods: {
    handleClose(done) {
     this.$confirm('确认关闭？')
          .then(_ => {
            done();
            this.dialogVisible = false
          })
          .catch(_ => {});
    },

    //将完整的base64转换为blob
    dataURLtoBlob(dataurl) {
      var arr = dataurl.split(","),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new Blob([u8arr], { type: mime });
    },

    downloadFile(url, name) {
      var a = document.createElement("a");
      a.setAttribute("href", url);
      a.setAttribute("download", name);
      a.setAttribute("target", "_blank");
      let clickEvent = document.createEvent("MouseEvents");
      clickEvent.initEvent("click", true, true);
      a.dispatchEvent(clickEvent);
    },
    downloadFileByBase64() {
      let fileName = this.param.title + ".png";
      var myBlob = this.dataURLtoBlob(this.shareImg);
      var myUrl = URL.createObjectURL(myBlob);
      this.downloadFile(myUrl, fileName);
    },
    openShare(row) {
      this.param = row;
      let params = {
        platform: row.platform,
        scene: row.scene,
        page: row.page,
      };
   
      this.$post("/user/user/generateQRCode",params).then((res) => {
        this.shareImg = res.data.data.img;
        this.dialogVisible = true;
        // uploadSave(base64ToFile(res.this.img, row.title + ".png"), picPath);
      });
    },
  },
};
</script>
